var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeasesIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.6667 6.6665L15 13.3998V26.5998L26.6667 33.3332L38.3333 26.5998V13.3998M26.6667 10.5165L33 14.1665L26.6667 17.8165L20.35 14.1665M0 11.6665V14.9998H11.6667V11.6665M18.3333 16.8498L25 20.6998V28.5165L18.3333 24.6832M35 16.8498V24.6832L28.3333 28.5165V20.6998M3.33333 18.3332V21.6665H11.6667V18.3332M6.66667 24.9998V28.3332H11.6667V24.9998",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeasesIcon);
export default __webpack_public_path__ + "static/media/leases_icon.72eccbf9a5e118bdeabb0b7a08908052.svg";
export { ForwardRef as ReactComponent };